import { createRequestActions } from "common/helpers/action";

export const initRegistriesKkmList = createRequestActions("CP.REGISTRIES.LIST.INIT");
export const scrollRegistriesKkmList = createRequestActions("CP.REGISTRIES.LIST.SCROLL");
export const searchRegistriesKkmList = createRequestActions("CP.REGISTRIES.LIST.SEARCH");
